import React from 'react';
import DispatchLogo from '../assets/integrations/dispatchme.png';
import ServiceBenchLogo from '../assets/integrations/servicebench.png';
import SamsungLogo from '../assets/integrations/samsung.svg';
import ServiceLiveLogo from '../assets/integrations/servicelive.png';
import ServicePowerLogo from '../assets/integrations/servicepower.png';

export default class IntegrationFeature extends React.Component {
	render() {
		return (
			<div className="section hide-mobile bg-primary-dark">
				<div className="container">
					<h3 className="mt-0 mb-5 h5 text-center text-white">Over 40 integrations and automations</h3>
					<div className="container-sm grid-5-col md-gap">
						<img src={DispatchLogo} width="100%" className="integration-icon inverted-color" alt="Dispatch.me logo"></img>
						<img src={ServiceBenchLogo} width="100%" className="integration-icon inverted-color" alt="ServiceBench logo"></img>
						<img src={SamsungLogo} width="100%" className="integration-icon inverted-color" alt="Samsung logo"></img>
						<img src={ServiceLiveLogo} width="100%" className="integration-icon inverted-color" alt="Service Live logo"></img>
						<img src={ServicePowerLogo} width="100%" className="integration-icon inverted-color" alt="ServicePower logo"></img>
					</div>
				</div>
			</div>
		)
	}
}